import { ISendEmailProjetoUseCase } from "../../../presentation/useCases/read/send_email_projeto_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * SendEmailProjetoUseCase
 */

export class SendEmailProjetoUseCase implements ISendEmailProjetoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async sendEmailProjeto(
    idProjeto: number,
    sendTo: string,
    subject: string,
    body: string,
    emailAttachment: string,
  ): Promise<void> {
    const emails = sendTo.split(';');

    emails.forEach(e => e.trim());

    await this.repository.sendEmailProjeto(
      idProjeto,
      emails,
      subject,
      body,
      emailAttachment,
    );
  }
}
